import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  clearBasicInformationData,
  clearEducationInformationData,
  clearFamilyInformationData,
  clearDemandsInformationData,
  clearDocumentsInformationData,
  clearPersonalInformationData,
} from "../slice";

export const useInitializeApp = () => {
  const dispatch = useDispatch();

  const setInitialData = useCallback(() => {
    dispatch(clearBasicInformationData());
    dispatch(clearEducationInformationData());
    dispatch(clearFamilyInformationData());
    dispatch(clearDemandsInformationData());
    dispatch(clearDocumentsInformationData());
    dispatch(clearPersonalInformationData());
  }, [dispatch]);

  return { setInitialData };
};
